type PlaceOrderOnSkipHandler = () => Promise<unknown> | void;

let pendingPlaceOrderOnSkip: PlaceOrderOnSkipHandler | null = null;

/** Before validate-transaction API: store what to run if 495 popup screen→ user skips. */
export const registerPlaceOrderOnSkip = (handler: PlaceOrderOnSkipHandler) => {
  pendingPlaceOrderOnSkip = handler;
};

/** Popup "No, I do not wish to add": take the handler, clear the slot, return it. */
export const runPlaceOrderOnSkip = (): PlaceOrderOnSkipHandler | null => {
  const handler = pendingPlaceOrderOnSkip;
  pendingPlaceOrderOnSkip = null;
  return handler;
};

/** Precheck passed, Manage Nominee clicked, unmount, or error — discard without running. */
export const cancelPlaceOrderOnSkip = () => {
  pendingPlaceOrderOnSkip = null;
};
